import { render, staticRenderFns } from "./KeyGroups.vue?vue&type=template&id=5365e764&"
import script from "./KeyGroups.vue?vue&type=script&lang=ts&"
export * from "./KeyGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports